var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":_vm.modalName}},[_c('b-modal',{attrs:{"id":_vm.modalName,"hide-footer":"","size":"lg"},scopedSlots:_vm._u([{key:"modal-title",fn:function(){return [_vm._v("\n            Export Line Items\n        ")]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }